import { type BranchKey, useForceDeleteConciseBranch } from '@festina-life/api'
import { notEmpty } from '@festina-life/core'
import { useTranslate } from '@festina-life/ui/hooks'

import { useAllConciseBranches } from '../../../../uiModels/branches/useAllConciseBranches'
import { DeleteBranchConfirmationButton } from './DeleteBranchConfirmationButton'

type Props = {
  branchKey: BranchKey
}

export const ForceDeleteBranchButton = ({ branchKey }: Props) => {
  const translate = useTranslate()
  const { mutateAsync: forceDeleteBranch, isPending: isDeletingBranch } =
    useForceDeleteConciseBranch()
  const conciseBranches = useAllConciseBranches()

  const blockingBranchNames =
    conciseBranches[branchKey.server]
      ?.filter(
        ({ baseBranchName, followsBranchName }) =>
          baseBranchName === branchKey.name ||
          followsBranchName === branchKey.name,
      )
      .map(({ name }) => name)
      .filter(notEmpty) ?? []

  return (
    <DeleteBranchConfirmationButton
      branchKey={branchKey}
      label={translate('branchDetailsPanel.tabs.manage.forceDeleteBranch')}
      confirmationTitle={translate(
        'branchDetailsPanel.tabs.manage.deleteBranch.confirmation.title',
        { branchName: branchKey.name },
      )}
      confirmationDescription={translate(
        'branchDetailsPanel.tabs.manage.deleteBranch.confirmation.description',
      )}
      onDelete={() =>
        forceDeleteBranch({
          branchName: branchKey.name,
          server: branchKey.server,
        })
      }
      isNameConfirmationRequired
      isLoading={isDeletingBranch}
      blockingBranchNames={blockingBranchNames}
    />
  )
}
